import type { CardReservationFeatures } from '../types/CardReservationFeatures';
import type { ReservationFeatures } from '../types/ReservationFeatures';

export const reservations: ReservationFeatures = {
    account: {
        newReservations: {
            enabled: false,
            _description: `
                Enables Account Reservations provided by the new
                Reservations Microservice
            `,
        },
        oldReservations: {
            enabled: false,
            _description: 'Enables Account Reservations provided by the legacy WebAPI',
        },
    },
    creditCard: {
        newReservations: {
            enabled: false,
            _description: `
                Enables Credit Card Reservations provided by the new
                Reservations Microservice
            `,
        },
        oldReservations: {
            enabled: false,
            _description: `
                Enables Credit Cards Reservations provided by the legacy WebAPI
            `,
        },
    },
    aggregationPerBaseCurrency: {
        enabled: false,
        _description: 'Enables reservation sums per base currency rather than foreign currency',
    },
};

export const cards: CardReservationFeatures = {
    bank_card: {
        reservations: {
            enabled: false,
            _description: 'Controls whether to show Reservations for Bank Card products.',
        },
    },
    credit: {
        reservations: {
            enabled: false,
            _description: 'Controls whether to show Reservations for Account products.',
        },
    },
};
